import type { IHttpClient } from '@/services/api/HttpClient';

export abstract class HttpService {
  protected httpClient: IHttpClient;

  constructor(httpClient: IHttpClient) {
    this.httpClient = httpClient;
  }
}
